import { Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslocoModule, TranslocoService } from "@jsverse/transloco";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { FluidModule } from "primeng/fluid";

import { TosDialogConfig } from "./tos.dialog.types";
import { BrandService } from "../../../../shared/branding/brand.service";
import { primeNgPageModules } from "../../../../shared/modules/prime-ng-common.module";
import { RanDatePipe } from "../../../../shared/pipes/ran-date.pipe";

@Component({
  templateUrl: "./tos.dialog.html",
  imports: [
    ...primeNgPageModules,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    FluidModule,
    TranslocoModule,
    RanDatePipe,
  ],
})
export class TosDialog {
  public lastUpdatedDate: Date | null = new Date("2025-10-31");
  public effectiveDate: Date | null = new Date("2025-10-31");

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig<TosDialogConfig>,
    public translocoService: TranslocoService,
    public brandService: BrandService,
  ) {}

  public acceptTosOnBehalfOfOrganization(): void {
    this.ref.close({ accepted: true });
  }

  public cancel(): void {
    this.ref.close({ accepted: false });
  }
}
